goog.provide("shadow.js.shim.module$src$svg$controls$media_player_call$media_pause_svg$default");
shadow.js.shim.module$src$svg$controls$media_player_call$media_pause_svg$default = shadow.js.shim.module$src$svg$controls$media_player_call$media_pause_svg.default;
